<template lang="pug">
b-modal#domainAvailableList(
  ref="domainAvailableList"
  :title="$t('ui.domain_list')"
  centered
  no-fade
  no-close-on-backdrop
  size="xl"
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    div
      .row
        .col-6
          b-form-group(:label="$t('ui.domain_group')" disabled)
            b-form-select(v-model="domainGroup" size="sm" @change="getDomainAvailableList(true)" disabled)
              option(value="") {{ $t('ui.all') }}
              option(value="MEMBER") {{ $t('ui.member') }}
              option(value="AFFILIATE") {{ $t('ui.affiliate') }}
        .col-6
          b-form-group(:label="$t('ui.account_id')" disabled).mb-0
            DebounceInput(
              size="sm"
              ref="account_id"
              required
              type="text"
              :dirty="$v.account_id.$dirty"
              :error="$v.account_id.$error"
              v-model.trim.lazy="$v.account_id.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
      b-form-group.mb-3
        .row
          .col-lg-9.mb-1
            b-pagination.float-left(
              size="sm"
              hide-ellipsis
              :total-rows="totalRow"
              :per-page="getPageSize"
              v-model="currentPage"
              @input="changedPage($event)")
          .col-lg-3.mb-1
            b-input-group(:prepend="$t('ui.page_size')" size="sm")
              b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
          .col-lg-12
            .clusterize-scroll.table-responsive
              table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                thead.thead-light
                  tr
                    th.text-center(width="4%")
                      span #
                    //- th(width="15%" v-if="!isOperator")
                    //-   span(:ttile="$t('ui.domain_id')") {{ $t('ui.domain_id') }}
                    th(width="10%")
                      span(:title="$t('ui.domain_name')") {{ $t('ui.domain_name') }}
                    th.text-center(width="10%" @click="sortOrder('domain_group')")
                      span(:title="$t('ui.domain_group')") {{ $t("ui.domain_group") }}
                      .float-right
                        i(:class="changeSortKey('domain_group')")
                    th.text-right(width="10%" @click="sortOrder('price')")
                      span(:title="$t('ui.price')") {{ $t("ui.price") }}
                      .float-right
                        i(:class="changeSortKey('price')")
                    //- th.text-right(width="10%" @click="sortOrder('created_by')" v-if="!isOperator")
                    //-   span(:title="$t('ui.created_by')") {{ $t("ui.created_by") }}
                    //-   i(:class="changeSortKey('created_by')")
                    //- th.text-right(width="10%" @click="sortOrder('created_date')" v-if="!isOperator")
                    //-   span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                    //-   .float-right
                    //-     i(:class="changeSortKey('created_date')")
                tbody
                  tr(v-if="domainList.length == 0")
                    td(:colspan="7").text-center
                      span {{ $t('message.no_data_available') }}
                  tr(v-for="(item, index) in domainList")
                    td.text-center
                      span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                    //- td(v-if="!isOperator")
                    //-   span(:title="item.domain_id") {{ item.domain_id }}
                    td
                      span(:title="item.domain_name") {{ item.domain_name }}                      
                      span.float-right(v-if="isEditAccess")
                        a.fa.fa-shopping-cart.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="purchaseDomain(item)" :title="$t('ui.purchase')")
                    td.text-center
                      span(:title="item.domain_group") {{ item.domain_group }}
                    td.text-right
                      span(:title="$n(item.price, 'currency')") {{ item.price ? $n(item.price, 'currency') : "-" }}
                    //- td.text-right(v-if="!isOperator")
                    //-   span(:title="item.created_by") {{ item.created_by }}
                    //- td.text-right(v-if="!isOperator")
                    //-   span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
    //- .row
    //-   .col-12
    //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: { 
    item: {
      type: Object
    },
  },
  data() {
    return {
      account_id: null,
      domainList: [],
      domainGroup: "MEMBER",
      domainName: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      currentPage: 1,
      totalRow: 0,
      sortKey: "",
      sortType: "asc",
    };
  },
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    // operatorID() {
    //   return this.$store.getters.selectedOperatorID;
    // },
    isEditAccess() {
      return this.$helpers.showActionButton("e_domainlist");
    }
  },
  validations: {
    account_id: {
      required,
      alphaNum,
      minLength: minLength(6),
      maxLength: maxLength(20)
    }
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getDomainAvailableList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getDomainAvailableList: function(isSearch, evt) {
      let url = config.domainDefaultAvailableList2();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        module: this.domainGroup,
        domain_name: this.domainName,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.domainList = response.data.dt;
                this.totalRow = this.domainList.length > 0 ? this.domainList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    purchaseDomain: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.purchase_domain_confirm", { name: item.domain_name }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmPurchaseDomain(item);
          } else {
            this.getDomainAvailableList();
          }
        });
    },
    confirmPurchaseDomain(item) {
      let url = config.domainDefaultBuyUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        domain_id: item.domain_id,
        operator_id: this.account_id
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.handlePurchaseSuccess(item.domain_name);
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getDomainAvailableList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handlePurchaseSuccess: function(domain) {
      this.getDomainAvailableList();

      this.$swal({
        title: this.$t("message.purchase_domain_success"),
        html: "<div>" + this.$t("ui.your_website") + ": </div>" +
              "<div id='text-to-copy'><a href='https://" + domain + "' target='_blank'>" + domain + "</a></div>",         
        type: "success",
        // showCancelButton: true,
        // confirmButtonText: this.$t("ui.copy"),
        cancelButtonText: this.$t("ui.ok"),
        allowOutsideClick: false
      }).then(isConfirm => {
        if (isConfirm.value) {
          // this.$helpers.selectText('text-to-copy')
          // try {
          //   var successful = document.execCommand('copy')
          //   this.$swal(this.$t("ui.success"), this.$t("ui.copy_success"), "success");
          // } catch (ex) {
          //   this.$swal(this.$t("ui.failed"), this.$t("ui.copy_failed"), "error");
          // }
        } else if (
          // Read more about handling dismissals
          isConfirm.dismiss === this.$swal.DismissReason.cancel
        ) {

        }
      });
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getDomainAvailableList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getDomainAvailableList();
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.domainList = [];
      this.account_id = this.item.account_id;
      this.getDomainAvailableList();
    }
  }
};
</script>
  